/**
 * @generated SignedSource<<705b9b75b47a20eb794bc6535bbebaa5>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type AddressValidityResponseError =
  | 'DELIVERY_POINT_NOT_FOUND'
  | 'EMPTY_FIELDS'
  | 'INVALID_BUILDING'
  | 'INVALID_MULTI_UNIT'
  | 'INVALID_STATE'
  | 'INVALID_STREET_NUMBER'
  | 'INVALID_SUITE_NUMBER'
  | 'MISSING_OR_AMBIGUOUS_DIRECTIONAL'
  | 'MULTIPLE_MATCHES'
  | 'NON_RESIDENTIAL_ADDRESS'
  | 'PO_BOX'
  | 'PRIMARY_CARDHOLDER_RESTRICTED_STATE'
  | 'RH_IDENTI_API_ERROR'
  | 'RH_INVALID_ADDRESS'
  | 'RH_UPSTREAM_API_ERROR'
  | 'SUITE_REQUIRED_BUT_MISSING'
  | 'UNEXPECTED_ERROR'
  | 'ZIP_CODE_NOT_FOUND'
  | '%future added value';
export type ResidencyPurpose = 'BILLING' | 'RESIDENTIAL' | 'SHIPPING' | 'TRANSFER_RECIPIENT' | '%future added value';
export type AddressValidityRequest = {
  identityId?: string | null;
  locality: string;
  primaryAddressLine: string;
  purpose?: ResidencyPurpose | null;
  secondaryAddressLine?: string | null;
  subdivision: string;
  zip4?: string | null;
  zip5: string;
};
export type ResidentialAddressPageValidateAddressQuery$variables = {
  q: AddressValidityRequest;
};
export type ResidentialAddressPageValidateAddressQuery$data = {
  readonly addressValidity: {
    readonly address: {
      readonly id: string;
      readonly locality: string;
      readonly primaryAddressLine: string;
      readonly secondaryAddressLine: string | null;
      readonly streetAddress: string;
      readonly subdivision: string;
      readonly zip: string;
    };
    readonly addressFormatted: {
      readonly id: string;
      readonly locality: string;
      readonly primaryAddressLine: string;
      readonly secondaryAddressLine: string | null;
      readonly streetAddress: string;
      readonly subdivision: string;
      readonly zip: string;
    } | null;
    readonly error: AddressValidityResponseError | null;
    readonly errorSkippable: boolean;
  };
};
export type ResidentialAddressPageValidateAddressQuery = {
  response: ResidentialAddressPageValidateAddressQuery$data;
  variables: ResidentialAddressPageValidateAddressQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'q',
      },
    ],
    v1 = [
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'id',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'streetAddress',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'primaryAddressLine',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'secondaryAddressLine',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'locality',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'subdivision',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'zip',
        storageKey: null,
      },
    ],
    v2 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'q',
            variableName: 'q',
          },
        ],
        concreteType: 'AddressValidityResponse',
        kind: 'LinkedField',
        name: 'addressValidity',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'Address',
            kind: 'LinkedField',
            name: 'address',
            plural: false,
            selections: v1 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'Address',
            kind: 'LinkedField',
            name: 'addressFormatted',
            plural: false,
            selections: v1 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'error',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'errorSkippable',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'ResidentialAddressPageValidateAddressQuery',
      selections: v2 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'ResidentialAddressPageValidateAddressQuery',
      selections: v2 /*: any*/,
    },
    params: {
      cacheID: '4eba429b63f1f08cb2114c354c5722d5',
      id: null,
      metadata: {},
      name: 'ResidentialAddressPageValidateAddressQuery',
      operationKind: 'query',
      text: 'query ResidentialAddressPageValidateAddressQuery(\n  $q: AddressValidityRequest!\n) {\n  addressValidity(q: $q) {\n    address {\n      id\n      streetAddress\n      primaryAddressLine\n      secondaryAddressLine\n      locality\n      subdivision\n      zip\n    }\n    addressFormatted {\n      id\n      streetAddress\n      primaryAddressLine\n      secondaryAddressLine\n      locality\n      subdivision\n      zip\n    }\n    error\n    errorSkippable\n  }\n}\n',
    },
  };
})();

(node as any).hash = '412d8f71e35546d5be0089a440ea401a';

export default node;
